import api from './api';

export class DependentesService {
  getDependentesIRRF = async (matricula, token) => {
    const response = await api.get('ObterSAPDependentesIRRF', {
      params: {
        matricula,
        token,
      },
    });

    const dependentes =
      response.data[0].response['SOAP:Envelope']['SOAP:Body'][0][
        'ns0:MT_DepIRRFAssist_Response'
      ][0].item || [];

    return dependentes.map((item) => {
      return {
        matricula: item.PERNR ?? '',
        nome: item.FCNAM ?? '',
        dataNascimento: item.FGBDT ?? '',
        parentesco: item.FAMSA ?? '',
        sexo: item.FASEX ? item.FASEX[0] : '',
        nomeMae: item.ZZMAE ?? '',
        nomePai: item.ZZPAI ?? '',
        cpf: item.ZZCPF ?? '',
        isEstudante: item.ESTUD ?? '',
        isInvalido: item.STINV ?? '',
      };
    });
  };
}
